import { initializeTable } from '../tables';
import RowContextMenuButtonColumn from '../formatters/RowContextMenuButtonColumn';

export default function initializeComponentTypeListTable({ ...options }) {
    const rootElement = document.querySelector('#componentTypeListTable');

    const forcedFilter = [];
    const pillsContainerSelector = '.active-filters-container';

    initializeTable({
        tableElement: rootElement,
        filtersElement: document.querySelector(
            '#componentTypeListFilters .form-fields',
        ),
        ajaxURL: rootElement.dataset.ajaxUrl,
        forcedFilter: forcedFilter,
        pillsConfig: {
            containerSelector: pillsContainerSelector,
            ignoreFields: [],
        },
        initialSort: [{ column: 'value', dir: 'asc' }],
        rowContextMenu: function (e, row) {
            const rowData = row.getData();
            let menu = [
                {
                    label: gettext('Edytuj'),
                    action: function (e, row) {
                        window.location.href = rowData.update_url;
                    },
                },
            ];
            menu = menu.filter((item) => item);
            return menu;
        },
        columns: [
            { title: '#', formatter: 'rownum', width: 60, headerSort: false },
            {
                title: gettext('Nazwa'),
                field: 'value',
                headerSortFieldName: 'value',
                resizable: false,
            },
            {
                title: gettext('Grupa'),
                field: 'groups',
                resizable: false,
            },
            {
                title: gettext('Akcja'),
                resizable: false,
                headerSort: false,
                width: 100,
                formatter: RowContextMenuButtonColumn,
            },
        ],
        ...options,
    });
}
